module.exports = __webpack_public_path__ + "img/iris.46c7b6c1.png";